import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import RichVideo from '~/components/RichVideo.vue';

interface Props {
  data?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductVideo',
  props: {
    data: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { data: any };



const videoId = computed(() => {
  if (!props.data.link) return undefined;

  const url = new URL(props.data.link);
  const isYTBrowserLink = url.pathname === '/watch';
  return isYTBrowserLink
    ? url.searchParams.get('v')
    : url.pathname.replace('/', '');
});
const isVideoShowed = ref(false);

return { __sfc: true,props, videoId, isVideoShowed, RichVideo }
}

})